<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="20">
        <bd-aside></bd-aside>
      </pane>
      <pane size="80">
        <bd-main></bd-main>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import BdAside from '@/components/dashboard/main/todo/BdAside'
import BdMain from '@/components/dashboard/main/todo/BdMain'

export default {
  name: 'bd-todo',
  components: { BdAside, BdMain, Splitpanes, Pane },
  data () {
    return {
    }
  }
}
</script>

<style scope>
.splitpanes {
  /*background: #000000;*/
}
</style>
